/* @flow */
// typecheck: ignore file
import React from 'react';

import cx from 'classnames';

import styles from './styles/ChevronBox.css';

// UNTIL prop-types lint can detect Flow annotation
/* eslint-disable react/prop-types */
const ChevronBox = ({ className, children, direction, ...props }: { className?: ?string, children?: ?any, direction?: string}) => (
  <div
    {...props}
    className={cx(styles.this, className, {
      [styles.right]: direction === 'right',
      [styles.left]: direction !== 'right',
    })}>
    {children}
  </div>
);

export default ChevronBox;



// WEBPACK FOOTER //
// ./src/components/ChevronBox.jsx